import { render, staticRenderFns } from "./TenantTambahDialog.vue?vue&type=template&id=20f9a106&scoped=true"
import script from "./TenantTambahDialog.vue?vue&type=script&lang=js"
export * from "./TenantTambahDialog.vue?vue&type=script&lang=js"
import style0 from "./TenantTambahDialog.vue?vue&type=style&index=0&id=20f9a106&prod&scoped=true&lang=css"
import style1 from "./TenantTambahDialog.vue?vue&type=style&index=1&id=20f9a106&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f9a106",
  null
  
)

export default component.exports